import { getSummaryValue, makeExpEstRow, getTitle, makeExpEstHeaders, makeFactorTable } from '../utils'
import { findEpiSuiteGroupById } from '@/components/combined-predict/models/epiSuite/epiSuiteColumnGroups'

const modelSummaryMapper = (item, meta) => {
  const selectedValue = getSummaryValue(item?.selectedValue ?? item?.predicted, getTitle(meta))

  return {
    values: [selectedValue],
    tables: [
      {
        headers: makeExpEstHeaders(),
        rows: [makeExpEstRow(item?.experimental, item?.predicted, getTitle(meta))],
      },
    ],
  }
}

const modelDescriptorsMapper = (item) => ({
  tables: [makeFactorTable(item?.predicted?.model)],
})

const vp = (items) => {
  const item = items?.find((item) => item?.property === 'vaporPressure')
  const meta = findEpiSuiteGroupById('vaporPressure')

  return {
    title: getTitle(meta),
    description: meta?.description,
    helpPage: meta?.helpPage,
    summary: modelSummaryMapper(item, meta),
    modelDescriptors: modelDescriptorsMapper(item),
    modelOutput: item?.predicted?.model?.output,
  }
}

export { vp }
